import { Box, Button, TextField } from "@mui/material";
import React from "react";
import { apiRequest } from "../../services/apiClient";

export default function UserAdd({ onClose, onAdd }) {
    const [nom, setNom] = React.useState('');
    const [prenoms, setPrenoms] = React.useState('');
    const [mail, setMail] = React.useState('');
    const [load, setLoad] = React.useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(true);
        try {
            const response = await apiRequest('/user/create', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ nom, prenoms, mail })
            });
            // if (!response.ok) throw new Error('Failed to add user');
            // const data = await response.json();
            onAdd();
            onClose();
        } catch (error) {
            console.error(error);
            alert('Erreur lors de l\'ajout de l\'utilisateur');
        } finally {
            setLoad(false);
        }
    }

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2 }}>
            <TextField label="Nom" value={nom} onChange={(e) => setNom(e.target.value)} fullWidth margin="normal" required />
            <TextField label="Prénoms" value={prenoms} onChange={(e) => setPrenoms(e.target.value)} fullWidth margin="normal" required />
            <TextField label="Mail" type="email" value={mail} onChange={(e) => setMail(e.target.value)} fullWidth margin="normal" required />
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
                <Button onClick={onClose} disabled={load}>Annuler</Button>
                <Button type="submit" variant="contained" disabled={load}>{load ? 'Ajout en cours...' : 'Ajouter'}</Button>
            </Box>
        </Box>
    );
}